// removed by extract-text-webpack-plugin
module.exports = {"row":"_1F-LilFnhwGFbpDwIY9cG7","title":"_31qXogHbGQ-Gt3Hidkvmt6","field":"_3D-GXqSa3a6piGQY9lcOtg","count":"_1Q9AKjDH1zc8RbQkJ4_6Z7"};


//////////////////
// WEBPACK FOOTER
// ./app/dialogs/VerifyStock/style.scss
// module id = 1066
// module chunks = 0